import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { BattleResultChange } from '../../models/battle';
import { BattleService } from '../../services/battle.service';
import { AdminPageHeaderComponent } from '../shared/admin-page-header/admin-page-header.component';

@Component({
  selector: 'app-battle-result-change',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink, AdminPageHeaderComponent],
  templateUrl: './battle-result-change.component.html',
  styleUrls: ['./battle-result-change.component.scss'],
})
export class BattleResultChangeComponent implements OnInit {
  battle: BattleResultChange | null = null;
  loserResult = '';
  debitTransactionType = '';
  creditTransactionType = '';
  isLoading = true;
  isSubmitting = false;
  completed = false;
  error = '';
  private publicId = '';

  constructor(private route: ActivatedRoute, private battleService: BattleService) {}

  ngOnInit(): void {
    this.publicId = this.route.snapshot.paramMap.get('publicId') || '';
    this.battleService.getResultChange(this.publicId).subscribe({
      next: (battle) => { this.battle = battle; this.isLoading = false; },
      error: (error) => { this.error = error.error?.detail || 'Não foi possível carregar esta batalha.'; this.isLoading = false; },
    });
  }

  submit(): void {
    if (!this.battle || this.isSubmitting || this.completed || !this.loserResult || !this.debitTransactionType || !this.creditTransactionType) return;
    this.isSubmitting = true;
    this.error = '';
    this.battleService.changeResult(this.publicId, {
      expected_winner_id: this.battle.expected_winner_id,
      loser_result: this.loserResult,
      debit_transaction_type: this.debitTransactionType,
      credit_transaction_type: this.creditTransactionType,
    }).subscribe({
      next: (battle) => { this.battle = battle; this.completed = true; this.isSubmitting = false; },
      error: (error) => { this.error = error.error?.detail || 'Não foi possível alterar o resultado. Recarregue a página antes de tentar novamente.'; this.isSubmitting = false; },
    });
  }
}
